import React from 'react';
import OrderTable from './OrderTable';
import { Button } from 'react-bootstrap';
import { useTabOrders } from '../../hooks/useOrders';
import type { OrderSummary } from '../../api/schemas/OrderSummarySchema';
import type { Org } from '../../api/schemas/OrgSchema';

interface LoadMoreOrderTableProps {
  status: number;
  orgs: Org[];
  activeTab: string;
  filteredOrders?: OrderSummary[];
}

export const LoadMoreOrderTable = ({
  status,
  orgs,
  activeTab,
  filteredOrders,
}: LoadMoreOrderTableProps) => {
  const { data, fetchNextPage } = useTabOrders(status);

  const tabOrders = React.useMemo(
    () => data?.pages.flatMap(page => page),
    [data],
  );

  const loadMore = () => {
    fetchNextPage();
  };

  return (
    <div className="load-more-order-table">
      {/*  @ts-expect-error missing props? */}
      <OrderTable
        orders={filteredOrders !== undefined ? filteredOrders : tabOrders}
        orgs={orgs}
        activeTab={activeTab}
      />
      {!filteredOrders || filteredOrders.length > 0
        ? null
        : 'No results found.'}
      {filteredOrders ? null : (
        <Button className="load-more-btn" onClick={loadMore}>
          LOAD MORE
        </Button>
      )}
    </div>
  );
};
